

import { useState, useEffect, Fragment, CSSProperties } from "react";
import { StyleSheet, View, Text } from "react-native";
import { FONT } from "../../../value/staticValues";
import { requests } from "../../../common/RestAPI";
import { CustomTextInput, TextArea } from "../../base/CustomInputText";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';
import { useTranslation } from "react-i18next";
import { diskTypes } from "./VolumeData";
import { PLATFORM_URL } from "value/Url";
import CustomText from "components/base/CustomText";



interface VolumeAddProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
};


interface ImageDetail {
    imageId: string;
    imageName: string;
    imageSizeGb: string;
    imageFileSizeGb: string;
    imageFormatTypeCode: string;
    bootYn: boolean;
    osTypeCode: string;
    baseImageName: string;
    imageDesc: string;
}


VolumeAdd.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}



export default function VolumeAdd(props:VolumeAddProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeAddYn, setExecuteAddYn] = useState(false);

    const [volumeName, setVolumeName] = useState("");
    const [volumeDesc, setVolumeDesc] = useState("");
    const [volumeSizeGb, setVolumeSizeGb] = useState("1");

    const [imageId, setImageId] = useState("");
    const [imageTypeCode, setImageTypeCode] = useState("IMG");

    const [azId, setAzId] = useState("");
    const [projectId, setProjectId] = useState("");

    const [azList, setAzList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);
    const [imageTypeList, setImageTypeList] = useState<DropdownType[]>(diskTypes);
    const [imageList, setImageList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);
    const [imageDetailList, setImageDetailList] = useState<ImageDetail[]>([]);

    const [projectList, setProjectList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);

    const [volumeNameWarnYn, setVolumeNameWarnYn] = useState(false);
    const [volumeSizeGbWarnYn, setVolumeSizeGbWarnYn] = useState(false);

    const [projectChangeYn, setProjectChangeYn] = useState(false);
    const [imageChangeYn, setImageChangeYn] = useState(false);

    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {

                }
            } else {
                const successYn = checkVolumeData();
                if(successYn) {
                    setExecuteAddYn(true);
                } else {
                    executeResult({successYn: false}, false , '');
                }
            }

        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        if(stepIndex === 0) {
            loadAzList();
            loadProjectList();
        }
    }, [stepIndex])

    useEffect(() => {
        if(projectChangeYn) {
            setProjectChangeYn(false);
        }
    }, [projectChangeYn]);

    useEffect(() => {
        if(imageChangeYn) {
            setImageChangeYn(false);
        }
    }, [imageChangeYn]);


    useEffect(() => {
        if(projectId) {
            setImageId("");
            setImageTypeCode("IMG");
            setVolumeSizeGb("1");
        }
    }, [projectId])


    useEffect(() => {
        if(imageTypeCode) {
            setImageChangeYn(true);
            loadVmImageList();
        }
    }, [imageTypeCode]);


    useEffect(() => {
        if(executeAddYn) {
            executeAddVolume();
        }
    }, [executeAddYn]);

    function executeResult(result, closeYn, infoMessage) {
        setExecuteAddYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }



    function loadProjectList() {
        requests.get(PLATFORM_URL.PROJECT, {size: 9999})
        .then((response) => {
            setProjectList(response.data.items.map((v) => {
                return {
                    value: v.project_id,
                    label: v.project_name
                }
            }));
        })
        .catch((error) => {
            if(props.showMessageCb) {
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }

    function loadAzList() {
        requests.get(PLATFORM_URL.AZ, {size: 9999, availability_zone_active_yn: true})
        .then((response) => {
            setAzList(response.data.items.map((v) => {
                return {
                    value: v.availability_zone_id,
                    label: v.availability_zone_name,
                }
            }));
        })
        .catch((error) => {
            if(props.showMessageCb) {
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }


    function loadVmImageList() {
        if(imageTypeCode === "IMG") {

            requests.get(PLATFORM_URL.VM_IMAGE, {page: 1, size: 9999, vm_image_type_code: "IMG"})
            .then((response) => {
                setImageList(response.data.items?.map((v) => {
                    if(v.vm_image_format_type_code !== "ISO" && v.vm_image_status_code === "ACT") {
                        return {
                            value: v.vm_image_id,
                            label: v.vm_image_name,
                        }
                    } else {
                        return false;
                    }
                }).filter((v)=>{if(v !== false) return v}));

                setImageDetailList(response.data.items?.map((v) => {
                    if(v.vm_image_format_type_code !== "ISO" && v.vm_image_status_code === "ACT") {
                        return {
                            imageId: v.vm_image_id,
                            imageName: v.vm_image_name,
                            imageSizeGb: (v.virt_size_mb / 1024).toFixed(2).toString(),
                            imageFileSizeGb: (v.real_size_mb / 1024).toFixed(2).toString(),
                            imageFormatTypeCode: v.vm_image_format_type_code,
                            osTypeCode: v.os_type_code,
                            baseImageName: "",
                            imageDesc: v.vm_image_description
                        }
                    } else {
                        return false;
                    }
                }).filter((v)=>{if(v !== false) return v}));
            })
            .catch((error) => {
                if(props.showMessageCb) {
                    props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
                }
            });

        } else if(imageTypeCode === "VOL") {
            requests.get(PLATFORM_URL.PROJECT + '/' + projectId + PLATFORM_URL.VOLUME, {page: 1, size: 9999})
            .then((response) => {
                setImageList(response.data.items?.map((v) => {
                    if(v.volume_status_code === "AVB") {
                        return {
                            value: v.volume_id,
                            label: v.volume_name,
                        }
                    } else {
                        return false;
                    }
                }).filter((v)=>{if(v !== false) return v}));

                setImageDetailList(response.data.items?.map((v) => {
                    if(v.volume_status_code === "AVB") {
                        return {
                            imageId: v.volume_id,
                            imageName: v.volume_name,
                            imageSizeGb: v.volume_size_gb.toString(),
                            imageFileSizeGb: "0",
                            imageFormatTypeCode: '',
                            osTypeCode: "NONE",
                            baseImageName: v.base_vm_image_name ? v.base_vm_image_name : '',
                            imageDesc: v.volume_description ? v.volume_description : ''
                        }
                    } else {
                        return false;
                    }
                }).filter((v)=>{if(v !== false) return v}));
            })
            .catch((error) => {
                if(props.showMessageCb) {
                    props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
                }
            });

        } else if(imageTypeCode === "SNAP") {
            requests.get(PLATFORM_URL.PROJECT + '/' + projectId + PLATFORM_URL.VM_IMAGE, {page: 1, size: 9999, vm_image_type_code: "SNAP"})
            .then((response) => {
                setImageList(response.data.items?.map((v) => {
                    if(v.vm_image_format_type_code !== "ISO" && v.vm_image_status_code === "ACT") {
                        return {
                            value: v.vm_image_id,
                            label: v.vm_image_name,
                        }
                    } else {
                        return false;
                    }
                }).filter((v)=>{if(v !== false) return v}));

                setImageDetailList(response.data.items?.map((v) => {
                    if(v.vm_image_format_type_code !== "ISO" && v.vm_image_status_code === "ACT") {
                        return {
                            imageId: v.vm_image_id,
                            imageName: v.vm_image_name,
                            imageSizeGb: (v.virt_size_mb / 1024).toFixed(2).toString(),
                            imageFileSizeGb: (v.real_size_mb / 1024).toFixed(2).toString(),
                            imageFormatTypeCode: v.vm_image_format_type_code,
                            osTypeCode: v.os_type_code,
                            baseImageName: "",
                            imageDesc: v.volume_description ? v.volume_description : ''
                        }
                    } else {
                        return false;
                    }
                }).filter((v)=>{if(v !== false) return v}));
            })
            .catch((error) => {
                if(props.showMessageCb) {
                    props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
                }
            });
        } else if(imageTypeCode === "VOLSNAP") {
            requests.get(PLATFORM_URL.PROJECT + '/' + projectId + PLATFORM_URL.VOLUME_SNAPSHOT, {size: 9999})
            .then((response) => {
                setImageList(response.data.items?.map((v) => {
                    if(v.volume_snapshot_status_code === "AVB") {
                        return {
                            value: v.volume_snapshot_id,
                            label: v.volume_snapshot_name,
                        }
                    } else {
                        return false;
                    }
                }).filter((v)=>{if(v !== false) return v}));

                setImageDetailList(response.data.items?.map((v) => {
                    if(v.volume_snapshot_status_code === "AVB") {
                        return {
                            imageId: v.volume_snapshot_id,
                            imageName: v.volume_snapshot_name,
                            imageSizeGb: v.volume_size_gb.toString(),
                            imageFileSizeGb: "0",
                            imageFormatTypeCode: "",
                            osTypeCode: "NONE",
                            baseImageName: v.base_vm_image_name ? v.base_vm_image_name : "",
                            imageDesc: ''
                        }
                    } else {
                        return false;
                    }

                }).filter((v)=>{if(v !== false) return v}));
            })
            .catch((error) => {
                if(props.showMessageCb) {
                    props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
                }
            });
        } else {
            setImageList([]);
            setImageDetailList([]);
        }
    }


    function checkVolumeData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }

        setVolumeNameWarnYn(false);
        setVolumeSizeGbWarnYn(false);
        let message = "";
        let error = false;

        if(!volumeName || !volumeSizeGb) {
            message = t("MESSAGE_VM_BASE_INFO_ENTER_ERROR_MESSAGE");
            if(!volumeName) {
                setVolumeNameWarnYn(true);
            }
            if(!volumeSizeGb) {
                setVolumeSizeGbWarnYn(true);
            }
            error = true;
        }
        if(error == true) {
            executeResult({}, false, message);
        }

        return !error;
    }


    function executeAddVolume() {
        const body = {};
        body['volume'] = {
            volume_name: volumeName,
            volume_description: volumeDesc
        }
        body['project'] = {
            project_id: projectId
        }
        body['availability_zone'] = {
            availability_zone_id: azId
        }
        body['source_image'] = {
            volume_source_type_code: imageTypeCode,
            volume_size_gb: volumeSizeGb
        }
        if (imageTypeCode === "IMG" || imageTypeCode === "SNAP") {
            body['source_image']['vm_image_id'] = imageId;
        } else if(imageTypeCode === "VOL") {
            body['source_image']['volume_id'] = imageId;
        } else if(imageTypeCode === "VOLSNAP") {
            body['source_image']['volume_snapshot_id'] = imageId;
        }

        requests.post(PLATFORM_URL.VOLUME, body)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else if(response.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_VOLUME_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        })
        .catch((error) => {
            if(error.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_VOLUME_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else if(error.status === 400 && error.data && error.data.detail.indexOf("minDisk") >= 0) {
                executeResult({successYn: false}, false, t("MESSAGE_VOLUME_ADD_MIN_SIZE_ERROR_MESSAGE") + "(" + error.data.detail.substring(error.data.detail.indexOf("minDisk"), error.data.detail.indexOf(". (HTTP 400)")) + ")");
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }


    return (
        <View style={style.topContainer}>
            {
                stepIndex === 0 ?
                // 이름, 설명, 사용 유형, 사용 대상
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("VM_VOLUME_ADD_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        {
                            projectChangeYn === false ?
                        <View style={style.rowContainer}>
                            <CustomText text={t("TARGET_PROJECT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown
                                key={2}
                                width={300} height={36}
                                items={projectList}
                                setValue={setProjectId}
                                value={projectId}
                                defaultvalue={{label:"", value:""}}
                            />
                        </View>: null
                        }
                        <Text style={style.rowDescribeContainer}>
                            {t("DESCRIBE_TARGET_PROJECT")}
                        </Text>
                        <View style={style.rowContainer}>
                            <CustomText text={t("VM_VOLUME_NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput
                                key={3}
                                width={570} height={36}
                                value={volumeName}
                                type={"text"}
                                activeYn={projectId ? true : false}
                                inputCb={setVolumeName}
                                warnYn={volumeNameWarnYn}
                                placeHolderText={t("NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowTopAlignContainer}>
                            <Text style={style.columnText}>
                                {t("VM_VOLUME_DESCRIPTION_TEXT")}
                            </Text>
                            <TextArea
                                key={4}
                                width={570}
                                height={100}
                                value={volumeDesc}
                                type={"text"}
                                activeYn={projectId ? true : false}
                                inputCb={setVolumeDesc}
                                warnYn={false}
                                placeHolderText={t("DESCRIPTION_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowDivContainer}/>
                    </View>
                    <Text style={style.titleText}>{
                        t("DETAIL_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("VM_AVAIL_ZONE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown
                                key={5}
                                width={300} height={36}
                                items={azList}
                                setValue={setAzId}
                                disable={projectId ? false : true}
                                defaultvalue={{label:"", value:""}}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("VM_VOLUME_SOURCE_TYPE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown
                                key={5}
                                width={300} height={36}
                                items={imageTypeList}
                                value={imageTypeCode}
                                setValue={setImageTypeCode}
                                disable={projectId && azId ? false : true}
                                defaultvalue={{label:t("IMAGE_TYPE_TEXT"), value:"IMG"}}
                            />
                        </View>
                        {
                            imageChangeYn === false && imageTypeCode !== "BLK"?
                            <Fragment>
                                <View style={style.rowContainer}>
                                    <CustomText text={t("VOLUME_SOURCE_SELECT_TEXT")} fontStyle={style.columnTextarea} asterisk={true}/>
                                    <CustomDropDown
                                        key={8}
                                        width={570} height={36}
                                        items={imageList}
                                        value={imageId}
                                        setValue={setImageId}
                                        disable={projectId && azId ? false : true}
                                    />
                                </View>
                                <View style={{
                                    width: 570, minHeight: 90,
                                    marginLeft: 150,
                                    marginBottom: 40,
                                    borderRadius: 10,
                                    backgroundColor: "#f5f7fa",
                                    paddingTop: 20, paddingBottom: 10, paddingLeft: 20, paddingRight: 10
                                    }}>

                                    {(()=>{
                                        if(imageTypeCode === "IMG" || imageTypeCode === "SNAP") {
                                            for(let imageDetail of imageDetailList) {
                                                if(imageDetail.imageId === imageId) {
                                                    return (
                                                        <Fragment>
                                                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 10}}>
                                                                <Text style={{
                                                                    width: 130,
                                                                    height: 20,
                                                                    fontFamily: FONT.MEDIUM,
                                                                    fontSize: 12,
                                                                    color: "#333"
                                                                }}> {t("FILE_SIZE_TEXT")}
                                                                </Text>
                                                                <Text style={{
                                                                    height: 20,
                                                                    fontFamily: FONT.MEDIUM,
                                                                    fontSize: 12,
                                                                    color: "#333"
                                                                }}> {imageDetail.imageFileSizeGb} GB
                                                                </Text>
                                                            </View>
                                                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 10}}>
                                                                <Text style={{
                                                                    width: 130,
                                                                    height: 20,
                                                                    fontFamily: FONT.MEDIUM,
                                                                    fontSize: 12,
                                                                    color: "#333"
                                                                }}> {t("VIRT_VOLUME_SIZE_TEXT")}
                                                                </Text>
                                                                <Text style={{
                                                                    height: 20,
                                                                    fontFamily: FONT.MEDIUM,
                                                                    fontSize: 12,
                                                                    color: "#3a8344"
                                                                }}> {imageDetail.imageSizeGb} GB
                                                                </Text>
                                                            </View>
                                                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 10}}>
                                                                <Text style={{
                                                                    width: 130,
                                                                    height: 20,
                                                                    fontFamily: FONT.MEDIUM,
                                                                    fontSize: 12,
                                                                    color: "#333"
                                                                }}> {t("DISK_FORMAT_TEXT")}
                                                                </Text>
                                                                <Text style={{
                                                                    height: 20,
                                                                    fontFamily: FONT.MEDIUM,
                                                                    fontSize: 12,
                                                                    color: "#3a8344"
                                                                }}> {imageDetail.imageFormatTypeCode}
                                                                </Text>
                                                            </View>
                                                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 10}}>
                                                                <Text style={{
                                                                    width: 130,
                                                                    height: 20,
                                                                    fontFamily: FONT.MEDIUM,
                                                                    fontSize: 12,
                                                                    color: "#333"
                                                                }}> {t("GUEST_OS_TEXT")}
                                                                </Text>
                                                                <Text style={{
                                                                    height: 20,
                                                                    fontFamily: FONT.MEDIUM,
                                                                    fontSize: 12,
                                                                    color: "#0853fb"
                                                                }}> {imageDetail.osTypeCode}
                                                                </Text>
                                                            </View>
                                                        </Fragment>
                                                    )
                                                }
                                            }
                                        } else {
                                            for(let imageDetail of imageDetailList) {
                                                if(imageDetail.imageId === imageId) {
                                                    return (
                                                        <Fragment>
                                                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 10}}>
                                                                <Text style={{
                                                                    width: 130,
                                                                    height: 20,
                                                                    fontFamily: FONT.MEDIUM,
                                                                    fontSize: 12,
                                                                    color: "#333"
                                                                }}> {t("VM_VOLUME_SIZE_TEXT")}
                                                                </Text>
                                                                <Text style={{
                                                                    height: 20,
                                                                    fontFamily: FONT.MEDIUM,
                                                                    fontSize: 12,
                                                                    color: "#3a8344"
                                                                }}> {imageDetail.imageSizeGb} GB
                                                                </Text>
                                                            </View>
                                                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 10}}>
                                                                <Text style={{
                                                                    width: 130,
                                                                    height: 20,
                                                                    fontFamily: FONT.MEDIUM,
                                                                    fontSize: 12,
                                                                    color: "#333"
                                                                }}> {t("VM_BASE_IMAGE_TEXT")}
                                                                </Text>
                                                                <Text style={{
                                                                    height: 20,
                                                                    fontFamily: FONT.MEDIUM,
                                                                    fontSize: 12,
                                                                    color: "#333"
                                                                }}> {imageDetail.baseImageName}
                                                                </Text>
                                                            </View>
                                                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 10}}>
                                                                <Text style={{
                                                                    width: 130,
                                                                    height: 20,
                                                                    fontFamily: FONT.MEDIUM,
                                                                    fontSize: 12,
                                                                    color: "#333"
                                                                }}> {t("VM_VOLUME_DESCRIPTION_TEXT")}
                                                                </Text>
                                                                <Text style={{
                                                                    height: 20,
                                                                    fontFamily: FONT.MEDIUM,
                                                                    fontSize: 12,
                                                                    color: "#333"
                                                                }}> {imageDetail.imageDesc}
                                                                </Text>
                                                            </View>
                                                        </Fragment>
                                                    )
                                                }
                                            }
                                        }
                                    })()}
                                </View>
                            </Fragment>:null
                        }
                        <View style={style.rowContainer}>
                            <CustomText text={t("VOLUME_SIZE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput
                                key={12}
                                width={110} height={36}
                                value={volumeSizeGb}
                                type={"number"}
                                activeYn={projectId && azId && (imageTypeCode === 'BLK' || imageId)? true : false}
                                inputCb={setVolumeSizeGb}
                                warnYn={volumeSizeGbWarnYn}
                                placeHolderText={"50"}
                            />
                            <Text style={{marginLeft: 10, fontFamily: FONT.REGULAR, fontSize: 11, color: "#9ea0a5"}}>GB</Text>
                        </View>
                    </View>
                </View>
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    topContainer: {

    },
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",

    },
    optionalTitleText: {
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",

    },
    optionalTitleSubText: {
        marginTop: 3,
        marginLeft: 16,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        color: "#9ea0a5",
    },
    mainContainer: {
        marginTop: 38
    },
    mainDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
    },
    mainOptionalContainer: {
        borderStyle: "solid",
        borderTopWidth: 1,
        borderTopColor: "#eee",
        paddingVertical: 30,
    },
    optionalBackgroundContainer: {
        paddingLeft: 40,
        marginLeft: -40,
        paddingTop: 30,
        paddingBottom: 10,
        width: 800,
        backgroundColor: "#fafafa"
    },

    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowNopaddingContainer: {
        flexDirection: "row",
        marginBottom: 5,
        alignItems: "center",
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    },

    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    columnTextarea: {
        width: 150,
        marginTop: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    columnValue: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
    },
    columnHelpText: {
        width: 520,
        marginLeft: 160,
        marginTop: -20,
        marginBottom: 30,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        color: "#8c9299"
    },
    columnUnitText: {
        marginLeft: 10,
        marginTop: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        color: "#8c9299"
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    usageTargetColumnContainer:{
        width: 130,
    },
    calendarInputContainer: {

    },
    caledarInputDivContainer: {
        width: 20,

    },
    caledarInputDivText: {
        fontFamily: FONT.REGULAR,
        fontSize: 15,
        color: "#333",
        textAlign: "center"
    },
    optionalTitleContainer :{
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 30,
    },

    policyColumnDivContainer: {
        width: 60,
    },
    policyColumnTitleText: {
        width: 130,
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
    },
    columnSnapshotText: {
        marginRight: 25,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#8c9299",
    },
    snapshotContainer: {
        width: 570,
        height: 170,
        marginLeft: 150,
        paddingVertical: 20,
        paddingHorizontal: 40,
        borderRadius: 10,
        backgroundColor: "#f7f7f7"
    },
    timeDivText: {
        width: 20,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        color: "#333",
        textAlign: "center",
    },
    textInputConatiner: {
        flexDirection: "row",
        alignItems: "center"
    },
    mainOptionalBottomContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
    },

    deviceTopContainer: {
        flexDirection: "row",
        width: 800,
    },
    deviceMainContainer: {
        width: 680,
        minHeight: 100,
        paddingTop: 18,
        paddingHorizontal: 18,
        borderRadius: 6,
        borderStyle: "solid",
        borderWidth: 0.8,
        borderColor: "#d2d5d9",
        backgroundColor: "#fff",
    },
    deviceControlContainer: {
        width: 40,
        marginLeft: 10,
        alignItems: "center",
    },
    deviceBaseContainer: {
        marginBottom: 10,
    },
    columnDivContainer: {
        marginLeft: 24,
    },
    rowQosPolicyContainer: {
        width: 678,
        marginLeft: -18,
        paddingHorizontal: 20,
        paddingTop: 20,
        paddingBottom: 30,
        backgroundColor: "#f8f9fa"
    },
    rowQosPolicyDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginVertical: 15,
    },
    columnQosPolicyContainer: {

        marginLeft: 5,
        flexDirection: "row",
        alignItems: "flex-end",
    },
    columnQosPolicyUnitText: {
        marginLeft: 5,
        marginBottom: 2,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        color: "#8c9299"
    },
    columnQosPolicyTitleText: {


        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",

    },
    columnQosPolicyStartContainer: {
        width: 10,
    },
    columnQosPolicyDivContainer: {
        width: 30,
    },
    columnQosPolicyTitleStartContainer: {
        marginLeft: 50
    },
    columnQosPolicyTitleDivContainer: {
        marginLeft: 165,
    },
    columnQosPolicyTitleEndContainer: {
        marginLeft: 100,
    },
    columnQosPolicyTitleFirstContainer: {
        marginLeft: 60,
    },
    columnQosPolicyTitleSecondContainer: {
        marginLeft: 125,
    },
    columnQosPolicyTitleThirdContainer: {
        marginLeft: 135,
    },
    noDeviceConfigureText: {
        fontFamily: FONT.MEDIUM,
        fontWeight: "500",
        fontSize: 14,
        color: "#333",
    }
});

const className = {
    mainContainer: {
        marginTop: "38px",
        zIndex:10,
    },
    policyRowContainer: {
        height: "36px",
        display: "flex",
        marginBottom: "20px",
        alignItems: "center",
        zIndex: 10,
    },

    policyColumnContainer: {
        width: "335px",
        display: "flex",
        alignItems: "center",
        zIndex: 10,
    },
    rowDropdownContainer: {
        zIndex: "13",
        display: "flex",
        marginBottom: "30px",
        alignItems: "center"
    },
    radioLabelText: {
        fontFamily: FONT.REGULAR,
        fontSize: "12px",
        color: "#333",
    },
    checkRequestImgContainer: {
        width:"24px",
        height:"24px",
        marginLeft: "20px",
        marginRight: "10px",
        cursor: "pointer"
    },
    checkRequestImg: {
        width: "24px",
        height: "24px"
    },
    checkImg: {
        marginLeft: "20px",
        marginRight: "10px",
        width: "24px",
        height: "24px"
    },
    rowTargetContainer: {
        width: "800px",
        marginLeft: "-40px",
        marginBottom: "30px",
        padding:"25px 40px 0px",
        backgroundColor: "#f2f4f7",
    },





    radioListHeaderText: {
        fontFamily: FONT.MEDIUM,
        fontWeight: "500",
        fontSize: "12px",
        color: "#333"
    },
    radioListBodyNameText: {
        fontFamily: FONT.REGULAR,
        fontSize: "13px",
        color: "#333"
    },
    radioListBodyCapacityText: {
        fontFamily: FONT.REGULAR,
        fontSize: "12px",
        color: "#5c5c5c"
    },
    radioListBodyOsText: {
        fontFamily: FONT.REGULAR,
        fontSize: "12px",
        color: "#5c5c5c"
    },
    radioListBodyDescriptionText: {
        fontFamily: FONT.REGULAR,
        fontSize: "12px",
        color: "#9ea0a5",
        height: "15px",
        overflow: "hidden",
    },

    optionalImg: {
        width: "40px",
        height: "36px",
        marginLeft: "auto",
        cursor: "pointer",
    },
    rowSnapshotContainer: {
        marginTop: "-15px",
        marginBottom: "13px"
    },
    rowSnapshotConfigureContainer: {
        display: "flex",
        alignItems: "center",
        marginBottom: "17px",
        zIndex: 9
    },
    deviceRemoveButtonContainer: {
        width: "40px",
        height: "36px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#fff",
        marginBottom: "10px"
    },
    deviceRemoveButtonContainerDisabled: {
        width: "40px",
        height: "36px",
        cursor: "not-allowed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#fff",
        marginBottom: "10px"
    },
    deviceAddButtonContainer: {
        width: "40px",
        height: "36px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "10px",
        border: "solid 1px #d4d9db",
        backgroundColor: "#f2f3f5"
    },
};
